<template>
  <Transition name="modal-popup">
    <div v-if="store.state.open.searchbar" class="modal-mask">
      <div class="common-searchbar glass" :class="{expand: isExpand}">
        <div class="search-main-row">
          <div class="search-input-wrap">
            <img src="@/assets/svg/searchbar.svg" alt="searchbar">
            <input
                v-model="search4what"
                ref="searchInputRef"
                type="text"
                :placeholder="store.state.searchbar.placeholder"
                required
                class="search-input"
                @keyup.enter="doSearch"
                @keydown="handleInputKeydown"
            />
          </div>
          <div class="search-btn-group">
            <button class="btn-search" @click="doSearch">搜索</button>
            <button class="btn-cancel" @click="handleClose">取消</button>
          </div>
        </div>
        <div class="search-result-wrap" :class="{expand: isExpand}">
          <div v-if="searchLoading" class="result-loading">正在检索中...</div>
          <div v-else-if="searchResult.length === 0 && search4what.trim()" class="result-empty">暂无匹配内容</div>
          <div v-else class="result-list">
            <!-- 这里循环渲染搜索卡片 -->
            <div class="result-item" v-for="(item,index) in searchResult" :key="item?.id ?? index"
                 :class="{active:activeIndex === index}" @click="selectItem(item)">
              <div class="result-item-title">{{ getBizName(item) }}{{ item?.title }}</div>
              <div v-if="activeIndex === index">
                <svg t="1789741354019" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3785"
                     width="22" height="22">
                  <path d="M350.814815 797.392593c-5.499259 0-10.903704-2.085926-15.075556-6.257778l-113.777778-113.777778c-8.343704-8.343704-8.343704-21.807407 0-30.151111l0.18963-0.18963 113.588148-113.588148c8.343704-8.343704 21.807407-8.343704 30.151111 0s8.343704 21.807407 0 30.151111L267.188148 662.281481l98.702222 98.702223c8.343704 8.343704 8.343704 21.807407 0 30.151111-4.171852 4.171852-9.576296 6.257778-15.075555 6.257778z"
                        p-id="3786" fill="var(--laputa-svg-color)"></path>
                  <path d="M604.728889 683.614815h-367.881482c-11.757037 0-21.333333-9.576296-21.333333-21.333334s9.576296-21.333333 21.333333-21.333333h367.881482c71.86963 0 130.37037-58.500741 130.37037-130.37037v-208.592593c0-11.757037 9.576296-21.333333 21.333334-21.333333s21.333333 9.576296 21.333333 21.333333v208.592593c0 46.08-18.014815 89.505185-50.820741 122.216296C694.139259 665.6 650.714074 683.614815 604.728889 683.614815z"
                        p-id="3787" fill="var(--laputa-svg-color)"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import {ref, watch} from 'vue'
import {useRoute, useRouter} from "vue-router";
import request from "@/api/request";
import store from "@/store";

const route = useRoute()
const router = useRouter()
const searchInputRef = ref(null);
const search4what = ref("")
//分页与加载状态，后续做弹窗分页直接用
const searchLoading = ref(false)

// 点击搜索按钮/回车触发查询，这里是占位，你接入你的接口
const doSearch = async () => {
  const kw = search4what.value.trim()
  if (!kw) return
  searchLoading.value = true
  store.commit("searchbar/search", true)
  if ('blog' === route.name) {
    //博客组件监控他的变化
    store.commit("searchbar/blogSearchKeyword", kw)
  } else if ('message' === route.name) {
    store.commit("searchbar/messageSearchKeyword", kw)
  } else if ('createManage' === route.name) {
    store.commit("searchbar/createManageSearchKeyword", kw)
  } else if ('moment' === route.name) {
    store.commit("searchbar/momentSearchKeyword", kw)
  } else if ('blogDetail' === route.name) {
    store.commit("searchbar/blogDetailSearchKeyword", kw)
  } else if ('tool' === route.name) {
    store.commit("searchbar/toolSearchKeyword", kw)
  }
  searchLoading.value = false
}

// 监听弹窗状态变化，打开后自动聚焦输入框 + 0.5s唤起按钮
watch(() => store.state.open.searchbar, (isOpen) => {
  if ('blog' === route.name) {
    store.commit("searchbar/placeholder", "搜索文章标题、描述")
  } else if ('message' === route.name) {
    store.commit("searchbar/placeholder", "搜索昵称/邮箱/留言内容/回复内容")
  } else if ('createManage' === route.name) {
    store.commit("searchbar/placeholder", "搜索文章标题")
  } else if ('moment' === route.name) {
    store.commit("searchbar/placeholder", "搜索时刻内容")
  } else if ('blogDetail' === route.name) {
    store.commit("searchbar/placeholder", "搜索文章章节")
  } else if ('tool' === route.name) {
    store.commit("searchbar/placeholder", "搜索工具")
  }
  if (isOpen) {
    setTimeout(() => {
      //自动聚焦
      searchInputRef.value?.focus()
    }, 30)
  }
})


// ===== 新增变量 =====
const isExpand = ref(false)
const searchResult = ref([])
let abortController = null

// ===== 监听输入，控制展开收缩 + 防抖搜索 =====
const debounce = (fn, delay = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}
// 防抖搜索函数
const fetchSearch = debounce(async (kw) => {
  if (!kw.trim()) {
    searchResult.value = []
    return
  }
  searchLoading.value = true
  // 取消上一次请求
  if (abortController) abortController.abort()
  abortController = new AbortController()
  try {
    const response = await request.get("/v1/api/search/searchbar", {
      params: {keyword: kw},
      signal: abortController.signal
    })
    const resp = response.data;
    if (resp.responseCode === '0000') {
      searchResult.value = resp.data
    }
  } catch (err) {
    if (err.name !== "AbortError") {
      console.error(err)
    }
  } finally {
    searchLoading.value = false
  }
})

// 监听输入框关键词，控制展开并触发搜索
watch(search4what, (val) => {
  if (val.trim() && ('blog' !== route.name && 'message' !== route.name && 'createManage' !== route.name && 'moment' !== route.name && 'blogDetail' !== route.name && 'tool' !== route.name)) {
    isExpand.value = true
    fetchSearch(val)
  } else {
    isExpand.value = false
    searchResult.value = []
  }
})

const handleClose = () => {
  store.commit('open/searchbar', false)
  search4what.value = ''
  //取消后去除提示
  store.commit("searchbar/placeholder", "聚焦搜索这座天空之城")
  store.commit(`open/header`, true)
  if ('blog' === route.name) {
    //博客组件监控他的变化
    store.commit("searchbar/blogSearchKeyword", "~")
  } else if ('message' === route.name) {
    store.commit("searchbar/messageSearchKeyword", "~")
  } else if ('createManage' === route.name) {
    store.commit("searchbar/createManageSearchKeyword", "~")
  } else if ('moment' === route.name) {
    store.commit("searchbar/momentSearchKeyword", "~")
  } else if ('tool' === route.name) {
    store.commit("searchbar/toolSearchKeyword", "~")
  }
  isExpand.value = false
  searchResult.value = []
  if (abortController) abortController.abort()
}

// 新增：高亮索引
const activeIndex = ref(-1)

// 上下方向键、回车逻辑
const handleInputKeydown = (e) => {
  onKeyDown(e)
  // 没有展开 / 没有搜索结果，直接退出
  if (!isExpand.value || searchResult.value.length === 0) return
  const total = searchResult.value.length
  switch (e.key) {
    case 'ArrowDown':
      e.preventDefault() // 阻止光标跳到行首尾
      activeIndex.value += 1
      // 超过最后一项，回到第一项
      if (activeIndex.value >= total) activeIndex.value = 0
      break
    case 'ArrowUp':
      e.preventDefault()
      activeIndex.value -= 1
      // 小于0，跳到最后一项
      if (activeIndex.value < 0) activeIndex.value = total - 1
      break
    case 'Enter':
      // 如果有高亮项，优先选中当前高亮；否则执行原来的doSearch
      if (activeIndex.value >= 0) {
        e.preventDefault()
        selectItem(searchResult.value[activeIndex.value])
      }
      break
  }
}
const onKeyDown = (e) => {
  if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === 'k') {
    e.preventDefault()
    handleClose()
  }
}

// 选中结果项的回调
const selectItem = (item) => {
  switch (item.bizType) {
    case 1:
      router.push({
        name: 'blogDetail',
        query: {
          id: item.contentId
        }
      })
      break
    case 2:
      router.push({
        name: 'moment',
        query: {
          id: item.contentId
        }
      })
      break
    case 3:
      router.push({
        name: 'bookDetail',
        query: {
          id: item.contentId
        }
      })
      break
    case 4:
      router.push({
        name: 'tool',
        query: {
          id: item.contentId
        }
      })
      break
  }
  isExpand.value = false
}

const getBizName = (item) => {
  if (item.bizType === 1) return "博客｜"
  else if (item.bizType === 2) return "时刻｜"
  else if (item.bizType === 3) return "读书｜"
  else if (item.bizType === 4) return "工具｜"
  else return item.bizType
}


// 【重要】搜索结果更新时，重置高亮索引
watch(searchResult, () => {
  activeIndex.value = -1
})

//路由切换自动关闭弹窗，防止弹窗挂页面
watch(() => route.path, () => {
  handleClose()
})

</script>

<style scoped>
/* 去掉黑色遮罩，只作为点击外层关闭的容器，背景完全透明 */
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 100;
  padding: 20px;
  box-sizing: border-box;
  background-color: transparent;
  pointer-events: none;
}

.common-searchbar {
  /* 顶部居中，不再垂直居中 */
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translate(-50%, 0) scale(1);
  width: 100%;
  max-width: 800px;
  max-height: 75vh;
  overflow-y: auto;
  border-radius: 30px;
  padding: 6px 14px;
  box-sizing: border-box;
  transition: all 0.42s cubic-bezier(0.25, 0.8, 0.25, 1);
  pointer-events: auto;
}

/* 新增：整行容器，输入区+按钮同一行，不破坏胶囊圆角 */
.search-main-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 2px 0;
}

/* 搜索输入框布局，放大镜+输入框同行 原有代码完全保留 */
.search-input-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: var(--laputa-fontsize-15);
  background: transparent;
}

/* ===== 按钮分裂滑入动画 ===== */
.search-btn-group {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  transition: all 0.28s ease-out;
  opacity: 1;
  transform: translateX(0);
}

.btn-search, .btn-cancel {
  padding: 8px 16px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: var(--laputa-fontsize-14);
}

.btn-search {
  background: var(--laputa-card-background-private-blue);
  color: var(--laputa-white);
}

.btn-cancel {
  background: var(--laputa-btn-cancel-background);
  color: var(--laputa-common-secondary-font-color);
}

/* ========== transition动画 修改位移：从上方滑入 全部原样保留 ========== */
/* 进入：同位置，从0.85缩放到1，透明度从0→1，位置完全不动 */
.modal-popup-enter-from .common-searchbar {
  transform: translate(-50%, 0) scale(0.85);
  opacity: 0;
}

.modal-popup-enter-active .common-searchbar {
  transition: all 0.36s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modal-popup-enter-to .common-searchbar {
  transform: translate(-50%, 0) scale(1);
  opacity: 1;
}

/* 离开：原地缩小消失 */
.modal-popup-leave-from .common-searchbar {
  opacity: 1;
}

.modal-popup-leave-to .common-searchbar {
  transform: translate(-50%, 0) scale(0.85);
  opacity: 0;
}

.modal-popup-leave-active .common-searchbar {
  transition: all 0.24s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* 展开状态：上圆角保持胶囊，下方改成大圆角 */
.common-searchbar.expand {
  border-radius: 30px 30px 30px 30px;
}

.search-result-wrap {
  max-height: 0;
  overflow: hidden;
  transition: all 0.42s cubic-bezier(0.25, 0.8, 0.25, 1);
  padding: 0 10px;
}

.search-result-wrap.expand {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px 1px;
}

.result-loading, .result-empty {
  padding: 16px 8px;
  color: var(--laputa-dark-gray);
  text-align: center;
  font-size: var(--laputa-fontsize-15);
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.result-item {
  display: flex;
  padding: 6px 12px;
  border-radius: 15px;
  cursor: pointer;
  justify-content: space-between; /* 左右两端分布 */
  align-items: center; /* 垂直居中，一般搭配一起用 */
}

.result-item:hover {
  /* 使用项目主色轮廓，不破坏毛玻璃质感 */
  background: var(--laputa-search-item-background-hover);
}

.result-item.active {
  /* 使用项目主色轮廓，不破坏毛玻璃质感 */
  outline: 1px solid var(--laputa-primary);
}

.result-item-title {
  font-size: var(--laputa-fontsize-15);
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
/* ========== 仅手机端覆盖，PC完全不受影响 ========== */
@media (max-width: 768px) {
  .modal-mask {
    padding: 10px !important;
  }
  .common-searchbar {
    top:40px;
    max-width: calc(100vw - 20px) !important;
    border-radius: 30px;
    max-height: calc(100vh - 12px - 20px);
  }
  .search-main-row {
    gap:8px !important;
  }
  .search-btn-group {
    display: flex !important;
    gap:6px !important;
  }
  .search-input-wrap {
    gap:8px !important;
  }
  .search-input {
    font-size: var(--laputa-fontsize-14);
    padding:6px 3px !important;
  }
  .btn-search,.btn-cancel{
    padding:6px 10px;
    font-size:var(--laputa-fontsize-14);
  }
  .search-result-wrap.expand {
    padding: 10px 4px !important; /* 原来 10px 0 → 左右增加4px内边距！ */
    margin-top:12px !important;
  }
  .result-item {
    padding: 10px 12px;
  }
  .result-item-title {
    justify-content: flex-start !important;
    font-size: var(--laputa-fontsize-14);
  }
}


</style>
